import { forwardRef } from 'react';
import { Box, type BoxProps } from '../Box/Box';

export type StackProps = Omit<BoxProps, 'display' | 'flexDirection'> & {
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
};

export const Stack = forwardRef<HTMLElement, StackProps>(
  ({ direction = 'column', gap = 'sm', ...props }, ref) => (
    <Box ref={ref} display="flex" flexDirection={direction} gap={gap} {...props} />
  ),
);
Stack.displayName = 'Stack';

// Row is Stack with direction="row" and vertically centered by default
export type RowProps = Omit<StackProps, 'direction'>;
export const Row = forwardRef<HTMLElement, RowProps>(
  ({ alignItems = 'center', ...props }, ref) => (
    <Stack ref={ref} direction="row" alignItems={alignItems} {...props} />
  ),
);
Row.displayName = 'Row';
